const commonFunctions = {
  //     LoadingAllSliderScript : () => {
  //         const script = document.createElement("script");
  //       script.src = `/js/default.js`;
  //       script.async = true;
  //       document.body.appendChild(script);

  //    },

  LoadingMapScript: () => {
    const script = document.createElement("script");
    script.src = `/js/mapLoadingScript.js`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  },

  LoadingCounterScript: () => {      
    const script = document.createElement("script");
    script.src = `/js/main.js`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  },
  LoadingBootstrapScript: () => {
    const script = document.createElement("script");
    script.src = `/js/bootstrap.js`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  },

    LoadingAllSliderScript: () => {
    const script = document.createElement("script");
    script.src = `/js/customSlider.js`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  },
    LoadingCustomMap: () => {
    const script = document.createElement("script");
    script.src = `/maps/custom-maploading.js`;
    script.async = true;
    document.body.appendChild(script);
  },
};

export default commonFunctions;
